// import { useCallback, useEffect, useRef, useState } from "react";
// import userProfile from "../../../src/assets/images/noProfile.png";
// import { ChevronDownIcon } from "@heroicons/react/20/solid";
// // import Select from "react-select";
// import debounce from "lodash/debounce";

// import {
//   activeIcon,
//   deactiveIcon,
//   DeleteIcon,
//   EditIcon,
//   ExportIcon,
//   EyesIcon,
//   ImportIcon,
//   inactiveIcon,
//   LeftArrow,
//   login,
//   PlusIcon,
//   rejected,
//   RequestAccess,
//   resentMail,
//   RestoreIcon,
//   RightArrow,
// } from "../../../src/assets/icons";
// import { useNavigate } from "react-router-dom";
// import { useSidebar } from "../../content/SidebarContent";
// import { routes } from "../../helpers/constants";
// import PageHeader from "../../components/PageHeader";
// import Modal from "../../components/Modal";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   reqToGetTenantList,
//   reqToEditStatusTenant,
//   reqToUpdateTenantStatus,
//   reqToResendInvite,
//   reqToAccessAccount,
//   reqToGetTempToken,
//   updateTenantAccessStatus,
// } from "../../redux/slices.js/tenants/tenantsSlice";
// import { IMAGE_URL } from "../../config";
// import { notify } from "../../helpers/commonFunctions";
// import Loader from "../../components/Loader";

// // const roleOptions = [
// // 	{ value: "HR", label: "HR" },
// // 	{ value: "Manager", label: "Manager" },
// // ];
// const statusOptions = [
//   { value: "On-boarding", label: "On-boarding" },
//   { value: "Employed", label: "Employed" },
//   { value: "Off-boarding", label: "Off-boarding" },
//   { value: "Resigned", label: "Resigned" },
// ];

// const TenantList = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   // const statusRef = useRef(null);
//   const pageRef = useRef(null);
//   const { setIsSidebarOpen } = useSidebar();
//   const [search, setSearch] = useState("");
//   const [activeTab, setActiveTab] = useState("All");
//   const [showModal, setShowModal] = useState(false);
//   const [activeModal, setActiveModal] = useState(false);
//   const [pendingModal, setPendingModal] = useState(false);
//   const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [accountAccess, setAccountAccess] = useState(false);
//   // const [openStatus, setOpenStatus] = useState(false);
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [pageMap, setPageMap] = useState({
//     All: 1,
//     Accepted: 1,
//     Pending: 1,
//   });
//   const [open, setOpen] = useState(false);
//   const [pageSize, setPageSize] = useState(20);
//   const pageSizes = [10, 20, 30, 50, 100];
//   const [selectedTenant, setSelectedTenant] = useState(null);

//   const tenants = useSelector((state) => state.tenants.tenants);
//   const loader = useSelector((state) => state.tenants.loader);
//   const totalCount = useSelector((state) => state.tenants.totalCount);

//   const currentPage = pageMap[activeTab];
//   const totalPages = Math.ceil(totalCount / pageSize);
//   const renderRangeStart = (currentPage - 1) * pageSize + 1;
//   const renderRangeEnd = Math.min(currentPage * pageSize, totalCount);

//   const goToPage = (page) => {
//     if (page >= 1) {
//       setPageMap((prev) => ({ ...prev, [activeTab]: page }));
//     }
//   };

//   const tabs = ["All", "Accepted", "Pending"];

//   const handleLoginToAccount = (user) => {
//     const data = {
//       tenant_id: user?.tenant?.id,
//     };
//     // window.open("http://localhost:3000/verifying-admin?adminToken=123", "_blank");

//     dispatch(
//       reqToGetTempToken({
//         data: data,
//         onSuccess: (res) => {
//           window.open(
//             `http://localhost:3000/verifying-admin?adminToken=${res?.data?.result}`
//           );
//           notify(res?.data?.message, "success");
//         },
//         onFailure: () => {},
//       })
//     );
//   };

//   const handleResendInvite = (user) => {
//     const data = {
//       email: user?.email,
//     };
//     dispatch(
//       reqToResendInvite({
//         data: data,
//         onSuccess: (res) => {
//           notify(res?.data?.message, "success");
//         },
//         onFailure: () => {},
//       })
//     );
//   };

//   const handleRequestAccess = (user) => {
//     const data = {
//       email: user?.email,
//       id: user?.tenant?.id,
//     };
//     dispatch(
//       reqToAccessAccount({
//         data: data,
//         onSuccess: (res) => {
//           notify(res?.data?.message, "success");
//           dispatch(
//             updateTenantAccessStatus({
//               tenant_id: data.id,
//               access_status: "requested",
//             })
//           );
//           setAccountAccess(false);
//         },
//         onFailure: () => {
//           setAccountAccess(false);
//         },
//       })
//     );
//   };

//   const handlePending = () => {
//     if (!selectedTenant) return;
//     dispatch(
//       reqToEditStatusTenant({
//         data: {
//           tenant_id: selectedTenant.tenant.id,
//           action: "deactive",
//           reason: "cool",
//         },
//         onSuccess: () => {
//           setShowModal(false);
//           setSelectedTenant(null);
//           dispatch(
//             reqToUpdateTenantStatus({
//               data: {
//                 tenant_id: selectedTenant.tenant.id,
//                 action: "deactive",
//                 reason: "cool",
//               },
//             })
//           );
//         },
//         onFailure: () => {
//           setShowModal(false);
//           setSelectedTenant(null);
//         },
//       })
//     );
//   };

//   const handleDeactive = () => {
//     if (!selectedTenant) return;
//     const reqObj = {
//       tenant_id: selectedTenant.tenant.id,
//       action: "inactive",
//       reason: "cool",
//     };
//     dispatch(
//       reqToEditStatusTenant({
//         data: reqObj,
//         onSuccess: () => {
//           setShowModal(false);
//           setSelectedTenant(null);
//           dispatch(reqToUpdateTenantStatus({ data: reqObj }));
//         },
//         onFailure: () => {
//           setShowModal(false);
//           setSelectedTenant(null);
//         },
//       })
//     );
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (pageRef.current && !pageRef.current.contains(event.target)) {
//         setOpen(false);
//       }
//     };

//     if (open) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [open]);

//   const handleActive = () => {
//     if (!selectedTenant) return;
//     const reqObj = {
//       tenant_id: selectedTenant.tenant.id,
//       action: "active",
//       reason: "cool",
//     };
//     dispatch(
//       reqToEditStatusTenant({
//         data: reqObj,
//         onSuccess: () => {
//           setActiveModal(false);
//           setSelectedTenant(null);
//           dispatch(reqToUpdateTenantStatus({ data: reqObj }));
//         },
//         onFailure: () => {
//           setActiveModal(false);
//           setSelectedTenant(null);
//         },
//       })
//     );
//   };

//   const debouncedSearch = useCallback(
//     debounce((val) => {
//       setSearch(val);
//     }, 500),
//     []
//   );

//   // 2. Handle input change
//   const handleSearchChange = (val) => {
//     debouncedSearch(val);
//   };

//   useEffect(() => {
//     return () => {
//       debouncedSearch.cancel();
//     };
//   }, [debouncedSearch]);

//   const fetchFilteredTenants = useCallback(() => {
//     // const status = selectedStatus?.value;
//     const page = pageMap[activeTab] || 1;

//     dispatch(
//       reqToGetTenantList({
//         data: {
//           tab: activeTab.toLowerCase(),
//           search,
//           page,
//           limit: pageSize,
//         },
//         onSuccess: () => {},
//         onFailure: () => {},
//       })
//     );
//   }, [selectedStatus?.value, activeTab, pageMap, pageSize, search, dispatch]);

//   useEffect(() => {
//     fetchFilteredTenants();
//   }, [fetchFilteredTenants]);

//   // useEffect(() => {
//   //   const handleClickOutside = (event) => {
//   //     if (statusRef.current && !statusRef.current.contains(event.target)) {
//   //       setOpenStatus(false);
//   //     }
//   //   };

//   //   if (openStatus) {
//   //     document.addEventListener("mousedown", handleClickOutside);
//   //   }

//   //   return () => {
//   //     document.removeEventListener("mousedown", handleClickOutside);
//   //   };
//   // }, [openStatus]);

//   // const toggleDropdown = () => {
//   //   setOpenStatus((prev) => !prev);
//   // };

//   // const handleSelect = (item, type) => {
//   //   setSelectedStatus(item);
//   //   setOpenStatus(false);

//   //   setPageMap((prev) => ({ ...prev, [activeTab]: 1 }));
//   // };

//   return (
//     <>
//       {loader && <Loader />}
//       <section className="dashboard-page main-layout-page main-layout h-[calc(100vh-50px)]">
//         <div className="!p-0">
//           <div className="main-layout-wrapper bg-white h-screen flex flex-col sticky z-1 top-0">
//             <PageHeader
//               title="Tenant List"
//               description="Plan, prioritize, and accomplish your companies with us."
//               tabs={tabs}
//               activeTab={activeTab}
//               onTabChange={(tab) => {
//                 setActiveTab(tab);
//                 setSelectedStatus(null);
//                 setPageMap((prev) => ({ ...prev, [tab]: 1 }));
//               }}
//               onOpenSidebar={() => setIsSidebarOpen(true)}
//               hasSearch={true}
//               onSearchChange={handleSearchChange}
//             />

//             <div className="flex-1 right-sidebar h-full relative">
//               <div
//                 className={`right-sidebar-contend py-6 px-3 md:p-6 pb-[50px] h-full ${
//                   activeTab ? "right-sidebar-tab" : ""
//                 }`}
//               >
//                 {/* content */}
//                 <div
//                   className={`dashboard-all-btns mb-10 flex items-center gap-5 flex-wrap justify-between`}
//                 >
//                   {/* <div className="flex-none all-btns flex items-center gap-5 ">
//                   <div className="relative inline-block text-left min-w-[150px]">
//                     <Select
//                       className="react-select-dropmenu"
//                       options={statusOptions}
//                       value={selectedStatus}
//                       onChange={(selectedOption) =>
//                         handleSelect(selectedOption, "status")
//                       }
//                       placeholder="Status"
//                       isClearable={false}
//                       isSearchable={false}
//                       classNamePrefix="react-select"
//                     />
//                   </div>
//                 </div> */}

//                   <div className="dashboard-btns flex items-center justify-start sm:justify-end flex-wrap gap-3 sm:gap-4">
//                     {/* <button
//                     className="text-white login-btn w-fit"
//                     // onClick={() => navigate(routes.exportForm)}
//                   >
//                     {ExportIcon} Export CSV
//                   </button>
//                   <button
//                     className="text-white login-btn w-fit"
//                     // onClick={() => navigate(routes.importCsv)}
//                   >
//                     {ImportIcon} Import CSV
//                   </button> */}
//                     <button
//                       className="text-white login-btn w-fit"
//                       onClick={() => navigate(routes.addTenants)}
//                     >
//                       {PlusIcon} Add Tenant
//                     </button>
//                   </div>
//                 </div>
//                 <div className="overflow-x-auto rounded-md bg-white box-shadow p-5 w-full common-scroll">
//                   <table className="min-w-[650px]">
//                     <thead className="bg-white-vlight p-2 h-[45px]">
//                       <tr>
//                         <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-250">
//                           Company Name
//                         </th>
//                         <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-200">
//                           Admin Name
//                         </th>
//                         <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-200">
//                           Email
//                         </th>
//                         <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-150">
//                           Type
//                         </th>
//                         <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-150">
//                           Strength
//                         </th>
//                         <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-150">
//                           Member Since
//                         </th>
//                         <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-150">
//                           Plan
//                         </th>
//                         <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-150">
//                           Active Employees
//                         </th>
//                         <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-150">
//                           Status
//                         </th>
//                         <th className="p-2 text-sub_span text-blue !font-extrabold text-right w-100">
//                           Actions
//                         </th>
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {tenants.length === 0 ? (
//                         <tr>
//                           <td
//                             colSpan="5"
//                             className="text-center py-6 text-gray-500 font-medium"
//                           >
//                             No data found.
//                           </td>
//                         </tr>
//                       ) : (
//                         tenants.map((user) => (
//                           <tr key={user.id} className="">
//                             <td className="py-3 px-2">
//                               <div className="flex gap-4 items-center">
//                                 <img
//                                   src={
//                                     user?.tenant?.logo
//                                       ? IMAGE_URL + user?.tenant?.logo
//                                       : userProfile
//                                   }
//                                   alt={user.name}
//                                   className="w-[42px] h-[42px] top-[426px] left-[340px] rounded-[10px] object-cover flex-none"
//                                 />
//                                 <span className="text-sub_span text-black !font-semibold">
//                                   {user.tenant?.name}
//                                 </span>
//                               </div>
//                             </td>
//                             <td className="py-3 px-2">
//                               <div className="flex gap-4 items-center">
//                                 <img
//                                   src={
//                                     user?.profile
//                                       ? IMAGE_URL + user?.profile
//                                       : userProfile
//                                   }
//                                   alt={user.name}
//                                   className="w-[42px] h-[42px] top-[426px] left-[340px] rounded-[10px] object-cover flex-none"
//                                 />
//                                 <span className="text-sub_span text-black !font-semibold">
//                                   {user?.name}
//                                 </span>
//                               </div>
//                             </td>
//                             <td>{user.email}</td>
//                             <td className="py-3 px-2">
//                               <div className="text-sub_span text-black !font-semibold">
//                                 {user?.tenant?.tenant_type}
//                               </div>
//                             </td>
//                             <td className="py-3 px-2">
//                               <div className="text-sub_span text-black !font-semibold">
//                                 {user?.tenant?.team_strength}
//                               </div>
//                             </td>
//                             <td className="py-3 px-2">
//                               <div className="text-sub_span text-black !font-semibold">
//                                 {user?.tenant?.how_long_old
//                                   ? `${new Date(
//                                       user.tenant.how_long_old
//                                     ).toLocaleDateString("en-US", {
//                                       year: "numeric",
//                                       month: "short",
//                                       day: "numeric",
//                                     })}`
//                                   : "-"}
//                               </div>
//                             </td>
//                             <td className="py-3 px-2">
//                               <div className="text-sub_span text-black !font-semibold">
//                                 {user?.tenant?.plan_tier}
//                               </div>
//                             </td>
//                             <td className="py-3 px-2">
//                               <div className="text-sub_span text-black !font-semibold">
//                                 {user?.tenant?.active_employee}
//                               </div>
//                             </td>
//                             <td className="py-3 px-2">
//                               <div
//                                 className={`px-4 py-[5px] flex items-center gap-2 w-fit text-sub_span text-black rounded-full !font-semibold ${
//                                   user?.tenant?.status === "active"
//                                     ? "bg-[#00D2611A] text-green-800"
//                                     : "bg-[#F03D361A] text-red-600"
//                                 }`}
//                               >
//                                 <span
//                                   className={`w-[10px] h-[10px] rounded-full ${
//                                     user?.tenant?.status === "active"
//                                       ? "bg-[#00D261]"
//                                       : user?.tenant?.status === "pending"
//                                       ? "bg-[#FFFF00]"
//                                       : "bg-[#F03D36]"
//                                   }`}
//                                 ></span>
//                                 {user?.tenant?.status?.charAt(0).toUpperCase() +
//                                   user?.tenant?.status?.slice(1)}
//                               </div>
//                             </td>
//                             <td className="py-3 px-2">
//                               <div className="flex items-center gap-3 justify-end">
//                                 {/* {user?.tenant?.status === "active" && (
//                                 <button
//                                   title="Request Access"
//                                   className="w-[16px] h-[16px]"
//                                   onClick={() => {
//                                     setSelectedUser(user);
//                                     setAccountAccess(true);
//                                   }}
//                                 >
//                                   {RequestAccess}
//                                 </button>
//                               )} */}
//                                 {user?.tenant?.status === "active" && (
//                                   <>
//                                     {user?.tenant?.access_status ===
//                                     "requested" ? (
//                                       <span className="text-xs text-yellow-500">
//                                         Pending
//                                       </span>
//                                     ) : user?.tenant?.access_status ===
//                                       "accepted" ? (
//                                       <button
//                                         title="Login"
//                                         className="text-[#4285F4] underline text-xs"
//                                         onClick={() => {
//                                           // Trigger login (or redirect logic)
//                                           handleLoginToAccount(user);
//                                         }}
//                                       >
//                                         {login}
//                                       </button>
//                                     ) : user?.tenant?.access_status ===
//                                       "rejected" ? (
//                                       <span className="text-xs text-red-500">
//                                         {rejected}
//                                       </span>
//                                     ) : (
//                                       // Default case: no access yet, allow request
//                                       <button
//                                         title="Request Access"
//                                         className="w-[16px] h-[16px]"
//                                         onClick={() => {
//                                           setSelectedUser(user);
//                                           setAccountAccess(true);
//                                         }}
//                                       >
//                                         {RequestAccess}
//                                       </button>
//                                     )}
//                                   </>
//                                 )}

//                                 <button
//                                   title="Edit"
//                                   className="w-[16px] h-[16px]"
//                                   onClick={() =>
//                                     navigate(
//                                       routes.viewTenants.replace(
//                                         ":id",
//                                         user?.tenant?.id
//                                       )
//                                     )
//                                   }
//                                 >
//                                   {EyesIcon}
//                                 </button>

//                                 <button
//                                   title="Edit"
//                                   className="w-[16px] h-[16px]"
//                                   onClick={() =>
//                                     navigate(
//                                       routes.editTenants.replace(
//                                         ":id",
//                                         user?.tenant?.id
//                                       )
//                                     )
//                                   }
//                                 >
//                                   {EditIcon}
//                                 </button>
//                                 {user?.tenant?.status === "pending" && (
//                                   <div className="flex items-center gap-3 justify-end">
//                                     <button
//                                       title="Resend Invitation"
//                                       className="w-[16px] h-[16px]"
//                                       onClick={() => {
//                                         setSelectedUser(user);
//                                         setIsConfirmModalOpen(true);
//                                       }}
//                                     >
//                                       {resentMail}
//                                     </button>
//                                   </div>
//                                 )}
//                                 {user?.tenant?.status != "pending" && (
//                                   <div className="flex items-center justify-center">
//                                     {user?.tenant?.status != "active" ? (
//                                       <button
//                                         title="Activate"
//                                         className="w-[16px] h-[16px]"
//                                         onClick={() => {
//                                           setSelectedTenant(user);
//                                           setActiveModal(true);
//                                         }}
//                                       >
//                                         {deactiveIcon}
//                                       </button>
//                                     ) : (
//                                       <button
//                                         title="Deactivate"
//                                         className="w-[16px] h-[16px]"
//                                         onClick={() => {
//                                           setSelectedTenant(user);
//                                           setShowModal(true);
//                                         }}
//                                       >
//                                         {activeIcon}
//                                       </button>
//                                     )}
//                                   </div>
//                                 )}
//                               </div>
//                             </td>
//                           </tr>
//                         ))
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//                 {tenants.length > 0 && totalCount > 0 && (
//                   <div className="flex justify-between items-center mt-4 text-sm text-gray-600 flex-wrap gap-3">
//                     <div className="text-span !font-medium text-[#8899A8] font-poppins">
//                       {renderRangeStart} – {renderRangeEnd} of {totalCount}
//                     </div>
//                     <div className="flex items-center gap-3 justify-end ml-auto">
//                       <div className="flex items-center gap-1">
//                         <button
//                           onClick={() => goToPage(currentPage - 1)}
//                           disabled={currentPage === 1}
//                           className=" disabled:opacity-40"
//                         >
//                           {LeftArrow}
//                         </button>
//                         {[...Array(totalPages)].map((_, i) => (
//                           <button
//                             key={i}
//                             onClick={() => goToPage(i + 1)}
//                             className={`px-3 py-1 h-[32px] min-w-[32px] !font-normal font-poppins text-sub_span rounded ${
//                               currentPage === i + 1
//                                 ? "bg-blue text-white"
//                                 : "text-[#4E5D78]"
//                             }`}
//                           >
//                             {i + 1}
//                           </button>
//                         ))}
//                         <button
//                           onClick={() => goToPage(currentPage + 1)}
//                           disabled={currentPage === totalPages}
//                           className=" disabled:opacity-40"
//                         >
//                           {RightArrow}
//                         </button>
//                       </div>
//                       <div
//                         className="flex items-center justify-center bg-gray-50"
//                         ref={pageRef}
//                       >
//                         <div className="relative inline-block text-left">
//                           {/* Selector button */}
//                           <button
//                             onClick={() => setOpen(!open)}
//                             className="flex items-center gap-1 font-poppins !font-normal text-[#637381] text-sub_span bg-white border border-[#DFE4EA] rounded-md px-3 py-1.5 shadow-sm focus:outline-none"
//                           >
//                             {pageSize}{" "}
//                             <span className="font-poppins !font-normal text-[#637381]">
//                               / Page
//                             </span>
//                             <ChevronDownIcon className="w-4 h-4 ml-1 font-poppins !font-normal text-[#637381]" />
//                           </button>

//                           {/* Dropdown */}
//                           {open && (
//                             <ul className="absolute bottom-full right-0 mt-2 w-28 bg-white border border-gray-200 rounded-md shadow-lg z-10">
//                               {pageSizes.map((size) => (
//                                 <li
//                                   key={size}
//                                   onClick={() => {
//                                     setPageSize(size);
//                                     setPageMap((prev) => ({
//                                       ...prev,
//                                       [activeTab]: 1,
//                                     }));
//                                     setOpen(false);
//                                   }}
//                                   className={`px-4 py-2 font-poppins !font-normal cursor-pointer ${
//                                     pageSize === size
//                                       ? "font-semibold bg-gray-100"
//                                       : ""
//                                   }`}
//                                 >
//                                   {size} / Page
//                                 </li>
//                               ))}
//                             </ul>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//         {pendingModal && (
//           <Modal
//             show={pendingModal}
//             onClose={() => setPendingModal(false)}
//             onConfirm={handlePending}
//             title={`Pending`}
//           />
//         )}
//         {showModal && (
//           <Modal
//             show={showModal}
//             onClose={() => setShowModal(false)}
//             onConfirm={handleDeactive}
//             title={`Are you sure you want to deactivate User?`}
//           />
//         )}
//         {activeModal && (
//           <Modal
//             show={activeModal}
//             onClose={() => setActiveModal(false)}
//             onConfirm={handleActive}
//             title={`Are you sure you want to activate User?`}
//           />
//         )}
//         {isConfirmModalOpen && (
//           <Modal
//             show={isConfirmModalOpen}
//             onClose={() => setIsConfirmModalOpen(false)}
//             onConfirm={() => {
//               if (selectedUser) {
//                 handleResendInvite(selectedUser);
//               }
//               setIsConfirmModalOpen(false);
//               setSelectedUser(null);
//             }}
//             title={`Are you sure you want to resend email invitation?`}
//           />
//         )}
//         {accountAccess && (
//           <Modal
//             show={accountAccess}
//             onClose={() => setAccountAccess(false)}
//             onConfirm={() => {
//               if (selectedUser) {
//                 handleRequestAccess(selectedUser);
//               }
//               setIsConfirmModalOpen(false);
//               setSelectedUser(null);
//             }}
//             title={`Are you sure you want to request access for this tenant account?`}
//           />
//         )}
//       </section>
//     </>
//   );
// };

// export default TenantList;

import React, { useEffect, useRef, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import Select from "react-select";
import {
  RefreshIcon,
  AddTeamIcon,
  SearchIcon,
  PaginationLeftArrow,
  PaginationRightArrow,
  DownArrowSelect,
  threeDotsIcon,
  ViewDetailsIcon,
  EditProgramIcon,
  ManageCodesIcon,
  PauseProgramIcon,
  DeleteProgramIcon,
  resentMail,
  activeIcon,
  deactiveIcon,
  RequestAccess,
  rejected,
  login,
} from "../../assets/icons";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  reqToAccessAccount,
  reqToEditStatusTenant,
  reqToGetCountries,
  reqToGetTenantList,
  reqToResendInvite,
  reqToUpdateTenantStatus,
  updateTenantAccessStatus,
} from "../../redux/slices.js/tenants/tenantsSlice";
import { routes } from "../../helpers/constants";
import {
  reqToGetmodulesList,
  reqToGetPlanList,
} from "../../redux/slices.js/plans/plansSlice";
import Modal from "../../components/Modal";
import Table from "../../components/Tables";
import PaginationTab from "../../components/PaginationTab";
import { notify } from "../../helpers/commonFunctions";

const planOptions = [
  { value: "all", label: "All plans" },
  { value: "starter", label: "Starter" },
  { value: "growth", label: "Growth" },
];

export default function TenantList() {
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState(20);
  const pageSizes = [10, 20, 30, 50, 100];
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(planOptions[0]);
  const [plans, setPlans] = useState([]);
  const [modules, setModules] = useState();
  const [countries, setCountries] = useState();
  const tenants = useSelector((state) => state.tenants.tenants);
  const totalCount = useSelector(
    (state) => parseInt(state.tenants.totalCount) || 0
  );
  const totalPages = Math.ceil(totalCount / pageSize);

  const [loading, setLoading] = useState(false);
  const [openRow, setOpenRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [accountAccess, setAccountAccess] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    dispatch(
      reqToGetPlanList({
        data: {},
        onSuccess: (res) => {
          setPlans(res?.data || []);
        },
        onFailure: (err) => {
          console.error("Failed to fetch plans:", err);
        },
      })
    );
    dispatch(
      reqToGetmodulesList({
        data: {},
        onSuccess: (res) => {
          setModules(res?.data || []);
        },
        onFailure: (err) => {
          console.error("Failed to fetch modules:", err);
        },
      })
    );
    dispatch(
      reqToGetCountries({
        search: "",
        onSuccess: (res) => {
          setCountries(res?.data);
        },
        onFailure: (err) => console.error(err),
      })
    );
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenRow(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchData = () => {
    setLoading(true);
    dispatch(
      reqToGetTenantList({
        data: {
          search: searchTerm,
          plan: selectedPlan.value,
          tab: "all",
          page: currentPage,
          limit: pageSize,
        },
        onSuccess: () => {
          setLoading(false);
        },
        onFailure: () => {
          setLoading(false);
        },
      })
    );
  };

  useEffect(() => {
    fetchData();
  }, [searchTerm, selectedPlan, currentPage, pageSize, dispatch]);

  const getCountryName = (countryId) => {
    if (!countryId) return "Not provided";
    return countries?.find((c) => c.id === countryId)?.name || "Not provided";
  };

  const handleDeactive = () => {
    if (!selectedTenant) return;
    const reqObj = {
      tenant_id: selectedTenant.tenant.id,
      action: "inactive",
      reason: "cool",
    };
    dispatch(
      reqToEditStatusTenant({
        data: reqObj,
        onSuccess: () => {
          setShowModal(false);
          setSelectedTenant(null);
          dispatch(reqToUpdateTenantStatus({ data: reqObj }));
        },
        onFailure: () => {
          setShowModal(false);
          setSelectedTenant(null);
        },
      })
    );
  };

  const handleActive = () => {
    if (!selectedTenant) return;
    const reqObj = {
      tenant_id: selectedTenant.tenant.id,
      action: "active",
      reason: "cool",
    };
    dispatch(
      reqToEditStatusTenant({
        data: reqObj,
        onSuccess: () => {
          setActiveModal(false);
          setSelectedTenant(null);
          dispatch(reqToUpdateTenantStatus({ data: reqObj }));
        },
        onFailure: () => {
          setActiveModal(false);
          setSelectedTenant(null);
        },
      })
    );
  };

  const handleResendInvite = (user) => {
    const data = {
      email: user?.email,
    };
    dispatch(
      reqToResendInvite({
        data: data,
        onSuccess: (res) => {
          notify(res?.data?.message, "success");
        },
        onFailure: () => {},
      })
    );
  };

  const handleRequestAccess = (user) => {
    const data = {
      email: user?.email,
      id: user?.tenant?.id,
    };
    dispatch(
      reqToAccessAccount({
        data: data,
        onSuccess: (res) => {
          notify(res?.data?.message, "success");
          dispatch(
            updateTenantAccessStatus({
              tenant_id: data.id,
              access_status: "requested",
            })
          );
          setAccountAccess(false);
        },
        onFailure: (error) => {
          setAccountAccess(false);
        },
      })
    );
  };

  // Define table columns
  const columns = [
    {
      key: "name",
      dataIndex: "tenant",
      title: "Name",
      render: (value, record) => (
        <Link to={`/tenants/acme-co-operation/${value?.id}`}>
          {value?.name}
        </Link>
      ),
    },
    {
      key: "plan",
      dataIndex: "plan_tier",
      title: "Plan",
      render: (value, record) => (
        <span
          className={`rounded-full ${
            value === "Starter"
              ? "bg-[#F3F7FF] text-[#4285F4]"
              : "bg-[#FAFAFA] text-[#5C5B62]"
          } text-xs font-medium`}
        >
          {record.tenant.plan_tier}
        </span>
      ),
    },
    {
      key: "module",
      dataIndex: "tenant",
      title: "Module",
      render: (value, record) => (
        <div className="space-x-1 labels-span">
          {value?.modules?.map((m, j) => (
            <span
              key={j}
              className={`rounded-full text-xs font-medium
                ${
                  m.name === "Core HR"
                    ? "bg-[#F3F7FF] text-[#4285F4]"
                    : m.name === "Leave management"
                    ? "bg-[#F8FFCF] text-[#4285F4]"
                    : "bg-[#FFF3E3] text-black"
                }`}
            >
              {m.name}
            </span>
          ))}
        </div>
      ),
    },
    {
      key: "region",
      dataIndex: "tenant",
      title: "Region",
      render: (value, record) => getCountryName(value.country),
    },
    {
      key: "health",
      dataIndex: "tenant",
      title: "Health",
      render: (value, record) => (
        <span
          className={`rounded-full text-xs font-medium
            ${
              value.health === "Warning"
                ? "bg-[#F8FFCF] text-[#FAAC14]"
                : "bg-[#F3F7FF] text-[#4285F4]"
            }`}
        >
          {value.health || "Healthy"}
        </span>
      ),
    },
    {
      key: "trialDays",
      dataIndex: "tenant",
      title: "Trial days left",
      render: (value, record) => value?.trial_plan_remaining_days,
    },
    {
      key: "lastActive",
      dataIndex: "logout_time",
      title: "Last active",
    },
    {
      key: "accountOwner",
      dataIndex: "name",
      title: "Account owner",
    },
    {
      key: "status",
      dataIndex: "status",
      title: "Status",
      render: (value, record) => (
        <span
          className={`rounded-full text-xs font-medium
            ${
              value === "Active"
                ? "bg-[#E9FFDF] text-[#52C41A]"
                : "bg-[#F3F7FF] text-[#4285F4]"
            }`}
        >
          {value}
        </span>
      ),
    },
  ];

  // Define row actions
  const rowActions = {
    threeDotsIcon: threeDotsIcon,
    actions: (row) => [
      {
        label: "View details",
        icon: ViewDetailsIcon,
        to: `${routes.editProvisionTenants.replace(
          ":id",
          row.tenant?.id
        )}?tab=review`,
        onClick: null,
      },
      {
        label: "Edit tenant",
        icon: EditProgramIcon,
        to: routes.editProvisionTenants.replace(":id", row.tenant?.id),
        onClick: null,
      },
      // Request Access / Login Actions
      ...(row?.status === "active"
        ? [
            row.tenant?.access_status === "requested"
              ? {
                  label: "Access Pending",
                  icon: RequestAccess,
                  to: "#",
                  onClick: null,
                  className: "text-yellow-500 cursor-not-allowed",
                }
              : row.tenant?.access_status === "accepted"
              ? {
                  label: "Login to Account",
                  icon: login,
                  to: "#",
                  onClick: () => handleLoginToAccount(row),
                }
              : row.tenant?.access_status === "rejected"
              ? {
                  label: "Access Rejected",
                  icon: rejected,
                  to: "#",
                  onClick: null,
                  className: "text-red-500 cursor-not-allowed",
                }
              : {
                  label: "Request Access",
                  icon: RequestAccess,
                  to: "#",
                  onClick: () => {
                    setSelectedUser(row);
                    setAccountAccess(true);
                  },
                },
          ]
        : []),
      // Resend Invitation for pending status
      ...(row?.status === "pending"
        ? [
            {
              label: "Resend Invitation",
              icon: resentMail,
              to: "#",
              onClick: () => {
                setSelectedUser(row);
                setIsConfirmModalOpen(true);
              },
            },
          ]
        : []),
      // Activate/Deactivate Actions
      ...(row?.status !== "pending"
        ? [
            row?.status !== "active"
              ? {
                  label: "Activate",
                  icon: deactiveIcon,
                  to: "#",
                  onClick: () => {
                    setSelectedTenant(row);
                    setActiveModal(true);
                  },
                }
              : {
                  label: "Deactivate",
                  icon: activeIcon,
                  to: "#",
                  onClick: () => {
                    setSelectedTenant(row);
                    setShowModal(true);
                  },
                },
          ]
        : []),
    ],
  };

  return (
    <>
      <div className="rounded-md border-[1px] border-solid border-[#F3EFEF] space-y-8 sm:p-6 p-3">
        <div className="">
          <div className="heading flex gap-2 justify-between items-end mb-[24px]">
            <div className="heading-title space-y-1 ">
              <h1 className="text-h2 !font-medium mb-0">Tenants Overview</h1>
              <p className="text-span text-dark mb-0">
                Manage all tenants overview in the system
              </p>
            </div>
          </div>
        </div>
        <div className="chart-card">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 sm:mb-4 mb-3 flex-wrap">
            <div className="flex gap-2 sm:flex-row flex-col">
              <div className="relative">
                <div className="absolute left-3 top-3">{SearchIcon}</div>
                <input
                  type="text"
                  placeholder="Search tenants"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="bg-[#FAFAFA] px-6 ps-10 py-3 border-none outline-none text-[#787891] rounded-md w-full sm:w-60 text-sm"
                />
              </div>
              <div className="w-full sm:w-40">
                <Select
                  value={selectedPlan}
                  onChange={(option) => setSelectedPlan(option)}
                  options={planOptions}
                  className="text-sm"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: "#e5e7eb",
                      minHeight: "38px",
                      boxShadow: "none",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "0 6px",
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      padding: "0 6px",
                    }),
                  }}
                />
              </div>
            </div>

            <div className="heading-btns flex items-center gap-3">
              <button
                className="btn-light-gray flex items-center gap-2"
                onClick={fetchData}
                disabled={loading}
              >
                {loading ? (
                  <span className="loader w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></span>
                ) : (
                  RefreshIcon
                )}
                {loading ? "Refreshing..." : "Refresh"}
              </button>

              <button
                className="btn-light-blue"
                onClick={() => navigate(routes.provisionTenants)}
              >
                {AddTeamIcon} Provision tenants
              </button>
            </div>
          </div>

          <Table
            columns={columns}
            data={tenants}
            keyField="id"
            rowActions={rowActions}
            openRow={openRow}
            setOpenRow={setOpenRow}
            dropdownRef={dropdownRef}
            emptyMessage="No tenants found"
            onRowClick={(row) => {}}
          />

          <PaginationTab
            currentPage={currentPage}
            pageSize={pageSize}
            totalCount={totalCount}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            onPageSizeChange={setPageSize}
          />
        </div>
      </div>

      {/* Add these modals at the bottom of your JSX */}
      {showModal && (
        <Modal
          show={showModal}
          onClose={() => setShowModal(false)}
          onConfirm={handleDeactive}
          ModalTitle={"Deactivate User"}
          title={`Are you sure you want to deactivate User?`}
        />
      )}
      {activeModal && (
        <Modal
          show={activeModal}
          onClose={() => setActiveModal(false)}
          onConfirm={handleActive}
          ModalTitle={"Activate User"}
          title={`Are you sure you want to activate User?`}
        />
      )}
      {isConfirmModalOpen && (
        <Modal
          show={isConfirmModalOpen}
          onClose={() => setIsConfirmModalOpen(false)}
          onConfirm={() => {
            if (selectedUser) {
              handleResendInvite(selectedUser);
            }
            setIsConfirmModalOpen(false);
            setSelectedUser(null);
          }}
          ModalTitle={"Invitation Email"}
          title={`Are you sure you want to resend email invitation?`}
        />
      )}
      {accountAccess && (
        <Modal
          show={accountAccess}
          onClose={() => setAccountAccess(false)}
          onConfirm={() => {
            if (selectedUser) {
              handleRequestAccess(selectedUser);
            }
            setAccountAccess(false);
            setSelectedUser(null);
          }}
          ModalTitle={"Access Tenant"}
          title={`Are you sure you want to request access for this tenant account?`}
        />
      )}
    </>
  );
}
